import { Form, Select, Button, Row, Col } from "antd";
import React from "react";

type LocationFilterType = "state-city" | "zone";

const zoneOptions = ["City", "South", "North", "East", "West", "Central"];

export default function ContactAgentsForm(
  props: {
    initialValues?: Record<string, any>;
    states: string[];
    cities: string[]; 
    additionalFilters?: React.ReactNode;
    findAgents: (values: Record<string, any>) => void;
    filterCities: (value: string | undefined) => void;
    filterStates: (value: string | undefined) => void;
    isWidget?: boolean; // new optional prop
    locationFilterType?: LocationFilterType;
  }
) {
  const {
    states,
    cities,
    additionalFilters,
    findAgents,
    filterCities,
    filterStates,
    isWidget = true, // default to true
    locationFilterType = "state-city",
  } = props;
  
  return (
    <Form layout="vertical" onFinish={findAgents} initialValues={props.initialValues}>
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={isWidget ? 24 : 18}>
          <Row gutter={[16, 16]}>
            {
              !!additionalFilters && additionalFilters
            }

            {locationFilterType === "state-city" && (
              <>
                <Col xs={24} md={isWidget ? 24 : 12}>
                  <Form.Item label="Select State" name="state">
                    <Select
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
                      }
                      placeholder="Please select"
                      options={states.map((s:any) => ({label: s, value: s}))}
                      onChange={filterCities}
                      getPopupContainer={(trigger) => trigger.parentElement}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={isWidget ? 24 : 12}>
                  <Form.Item label="City" name="city">
                    <Select
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
                      }
                      placeholder="Please select"
                      options={cities.map((c:any) => ({label: c, value: c}))}
                      onChange={filterStates}
                      getPopupContainer={(trigger) => trigger.parentElement}
                    />
                  </Form.Item>
                </Col>
              </>
            )}

            {locationFilterType === "zone" && (
              <Col xs={24} md={isWidget ? 24 : 12}>
                <Form.Item label="Zone" name="zone">
                  <Select
                    allowClear
                    placeholder="Please select"
                    options={zoneOptions.map((zone) => ({ label: zone, value: zone }))}
                    getPopupContainer={(trigger) => trigger.parentElement}
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
        </Col>
        <Col xs={24} lg={isWidget ? 24 : 6}>
          <Button type="primary" className="find-button" htmlType="submit" block={isWidget}>Find Agent</Button>
        </Col>
      </Row>
    </Form>
  )
}